import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

import { SelectOption } from './select-option.model';
import { MatSelectChange } from '@angular/material/select';

@Component({
    selector: 'app-select-input',
    templateUrl: './select-input.component.html',
    styleUrls: ['./select-input.component.scss'],
    standalone: false
})
export class SelectInputComponent {
  @Input() dataTestId: string;
  @Input() errorMessage: string;
  @Input() formControlRef: FormControl;
  @Input() isDisabled = false;
  @Input() isFullWidth = false;
  @Input() label: string;
  @Input() placeholder: string;
  @Input() value: Object;

  @Input() autocomplete?: string = null;

  @Input() options: SelectOption[];

  @Output() selectionChange = new EventEmitter<MatSelectChange>();

  handleSelectionChange(change: MatSelectChange) {
    this.selectionChange.emit(change);
  }
}
